import Vue from 'vue/dist/vue.js';

(function () {
    ("use strict");

    document.addEventListener("DOMContentLoaded", onReady);

    function onReady() {
        if (document.querySelector('#blog-app')) {
            initApp();
        }
    }

    // initApp();
    function initApp() {
        new Vue({
            el: "#blog-app",
            data: {
                activeItem: 0,
                posts: [],
                fetchFinished: false,
                page: 1,
                allPostsLoaded: false,
                title: "Lade News",
            },
            computed: {},
            methods: {
                isActive(menuItem) {
                    return this.activeItem === menuItem;
                },
                setActive(menuItem) {
                    this.activeItem = menuItem;
                },
                getMorePosts() {
                    this.fetchFinished = false;
                    this.allPostsLoaded = false;

                    fetch(
                        `${PHP.site_url}/wp-json/wp/v2/posts?page=${this.page}&per_page=5&_embed=1`
                    ).then((response) => {
                        console.log(response);
                        if (response.status !== 200) {
                            this.allPostsLoaded = true;
                        }
                        const element = document.getElementById(
                            "scroll-here"
                        );
                        element.scrollIntoView({
                            behavior: "smooth",
                        });
                        response
                            .json()
                            .then((posts) => {
                                this.posts = posts
                                    .filter((el) => el.status === "publish")
                                    .map(
                                        ({
                                             id,
                                             slug,
                                             title,
                                             date,
                                             content,
                                             formatted_date,
                                         }) => ({
                                            id,
                                            slug,
                                            title,
                                            date,
                                            content,
                                            formatted_date,
                                        })
                                    );
                                this.activeItem = this.posts[0].id;
                                this.fetchFinished = true;
                                this.page++;
                            })
                            .catch((error) => {
                                this.errorMessage = error;
                                console.error("There was an error!", error);
                            });
                    });
                },
            },
            async created() {
                this.fetchFinished = false;
                this.allPostsLoaded = false;

                await fetch(
                    `${PHP.site_url}/wp-json/wp/v2/posts?page=${this.page}&per_page=5&_embed=1`
                )
                    .then((response) => {
                        response.json().then((posts) => {
                            this.posts = posts
                                .filter((el) => el.status === "publish")
                                .map(
                                    ({
                                         id,
                                         slug,
                                         title,
                                         date,
                                         content,
                                         formatted_date,
                                     }) => ({
                                        id,
                                        slug,
                                        title,
                                        date,
                                        content,
                                        formatted_date,
                                    })
                                );
                            this.activeItem = this.posts[0].id;
                            this.fetchFinished = true;
                            this.page++;
                        });
                    })
                    .catch((error) => {
                        this.errorMessage = error;
                        console.error("There was an error!", error);
                    });
            },
        });
    }
})();
